export default __webpack_public_path__ + "static/main6-0b36051f05ea088e204f3fb60c556ba1.png";